<script setup lang="ts">
import { RouterLink } from 'vue-router';
import { useLanguage } from '../composables/useLanguage';
import {
  Languages,
  languagesDropDownObject,
} from '../composables/useTranslations';
import { useTranslations } from '../composables/useTranslations';
import { useRouter } from 'vue-router';
import { currentLanguage, getLocalizedPath } from '../composables/useLanguage';
import { watch } from 'vue';

const { getPathForLanguage } = useLanguage();
const t = useTranslations();
const router = useRouter();

const handleLanguageChange = async (event: Event) => {
  const select = event.target as HTMLSelectElement;
  const newPath = getPathForLanguage(select.value as Languages);
  await router.push(newPath);
};

watch(currentLanguage, () => {
  document.title = t.value.metaDefaultTitle;
});
</script>

<template>
  <header
    class="sticky top-0 z-50 w-full bg-white backdrop-blur-xl border-b border-gray-200"
  >
    <div class="px-4 sm:px-6 h-16 flex items-center justify-between">
      <div class="flex items-center gap-6">
        <RouterLink :to="getLocalizedPath('/')" class="flex items-center gap-4">
          <span class="font-bold text-accent text-xl"> Language Rooms </span>
        </RouterLink>
        <span
          class="hidden sm:block text-xs px-3 py-1 rounded-full bg-[#F3F4F6] text-[#6B7280]"
        >
          {{ t.speakLearnConnect }}
        </span>
      </div>

      <nav class="md:flex items-center gap-8">
        <select
          v-model="currentLanguage"
          class="select min-w-32"
          @change="handleLanguageChange"
        >
          <option
            v-for="lang in languagesDropDownObject"
            :key="lang.code"
            :value="lang.code"
          >
            {{ lang.label }}
          </option>
        </select>
      </nav>
    </div>
  </header>
</template>
